/**
 * Marquee pause control.
 *
 * WCAG 2.2.2 requires a mechanism to pause, stop or hide anything that moves automatically for
 * more than five seconds. This is that mechanism. It is a real button because hover-to-pause
 * does not exist on a touchscreen and cannot be reached from a keyboard, and because automated
 * checkers do not flag a missing pause control — this one only gets caught by a person who
 * knows to look for it, so it ships with the section rather than after an audit.
 *
 * The preference is remembered for the session: someone who pauses motion once should not have
 * to pause it again on the next page.
 */
(function () {
  var KEY = 'dp:marquee-paused';

  function apply(marquee, paused) {
    var toggle = marquee.querySelector('[data-dp-marquee-toggle]');
    marquee.dataset.paused = paused ? 'true' : 'false';
    if (!toggle) return;
    var label = paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause;
    toggle.textContent = label;
    toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
  }

  function stored() {
    try {
      return sessionStorage.getItem(KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  document.querySelectorAll('[data-dp-marquee]').forEach(function (marquee) {
    // prefers-reduced-motion is handled in CSS, which stops the animation outright rather than
    // running it 3,000x faster the way a blanket duration override would. Nothing to do here.
    apply(marquee, stored());

    var toggle = marquee.querySelector('[data-dp-marquee-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', function () {
      var paused = marquee.dataset.paused !== 'true';
      apply(marquee, paused);
      try {
        sessionStorage.setItem(KEY, paused ? 'true' : 'false');
      } catch (error) {
        /* private mode — the toggle still works, it just won't persist */
      }
    });
  });
})();
